export * from 'component/Modal/Modal'
